// extracted by mini-css-extract-plugin
module.exports = {"step":"styles_step__3Efto","resultWrapper":"styles_resultWrapper__2ZWtz","resultTextContent":"styles_resultTextContent__yzpKB"};